import "./RankHolder.scss";
import rankholder1 from "../../assets/Home/april-2021.jpeg";
import rankholder2 from "../../assets/Home/april-2022.jpeg";
import rankholder3 from "../../assets/Home/April-2023.jpg";

const RankHonder = () => {
  const lines = Array.from({ length: 3 });

  return (
    <div className="rank">
      <div className="rank-heading">
        <div className="rank-holder-heading">
          <h3 className="rank-main-heading">Last three years University Gold Medalists & Rank Holders</h3>
          <div className="rank-code" style={styles.container}>
            {lines.map((_, index) => (
              <div key={index} style={styles.line}></div>
            ))}
          </div>
        </div>
      </div>
      <div className="rankholder-image">
        <div className="rankholder-image-box">
          <div className="img-hover">
            <img className="rank-img rank-img-1" src={rankholder1} alt="" />
            <div className="hover-text">
              <p className="para-white">University Gold Medalists & Rank Holders – April 2021</p>
            </div>
          </div>
          <div className="img-hover">
            <img className="rank-img rank-img-2" src={rankholder2} alt="" />
            <div className="hover-text">
              <p className="para-white">University Gold Medalists & Rank Holders – April 2022</p>
            </div>
          </div>
          <div className="img-hover">
            <img className="rank-img rank-img-3" src={rankholder3} alt="" />
            <div className="hover-text">
              <p className="para-white">University Gold Medalists & Rank Holders – April 2023</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
  },
  line: {
    width: "25px",
    height: "1px",
    color: "green",
    backgroundColor: "#0D553A",
    transform: "rotate(-150deg)",
    margin: "2px",
  },
};

export default RankHonder;
